document.addEventListener('click', function(e) {
    // Usamos closest para detectar el clic incluso si hacen clic en la imagen dentro del span
    const btn = e.target.closest('.btn-cerrar-alerta');
    if (btn) {
        const alerta = btn.closest('.alertaHijo');
        if (alerta) {
            cerrarAlertaEfecto(alerta);
        }
    }
});

function lanzarAlerta(mensaje, clase) {
    const contenedor = document.getElementById('cont-alertas');
    if (!contenedor) return;

    const nuevaAlerta = document.createElement('div');

    nuevaAlerta.className = `${clase} alertaHijo show--alert`; 
    
    nuevaAlerta.innerHTML = `
        <img class="svg-alerta" src="/public/build/img/icons/alerta.svg" alt="alerta">
        <span class="span-msg">
            <strong>Alerta: </strong>${mensaje}
        </span>
        <span class="btn-cerrar btn-cerrar-alerta">
            <img class="svg-cerrar" src="/public/build/img/icons/x.svg" alt="cerrar">
        </span>
    `;
    contenedor.appendChild(nuevaAlerta);
    setTimeout(() => {
        cerrarAlertaEfecto(nuevaAlerta);
    }, 7000); 
}

function cerrarAlertaEfecto(elemento) {
    if (!elemento) return;

    elemento.classList.remove("show--alert");
    elemento.classList.add("hide--alert");

    setTimeout(() => {
        if (elemento.parentNode) elemento.remove();
    }, 400);
}